import React from 'react'
import { withUserStore } from '../../../contexts/UserStore'
import { Input, Label } from '@byscott-io/corebyscott'
import PageView from '../PageView'
import Lex from '../../Shared/Lex'
import PageProvider from '../../../modules/PageProvider'

// new: invitation: email address, accountRole, team, teamRole
// invitation:
//   edit: email, accountRole, team, teamRole
//   delete
// accountsUser:
//   edit: accountRole, team, teamRole
//   delete

const Members = ({ userStore }) => {
  const form = {}
  let teams = null

  const getAccount = () => userStore.account

  const page = {
    clickUrl: (record) => 'member/' + record.id,
    formName: (record) => record?.recordType === 'accountsUsers' ? (userStore.lex['organization-member'] || 'Member') : (userStore.lex.invitation || 'Invitation'),
    recordType: () => 'accountsUsers',
    pageHeader: () => <h3><Lex term="member" plural /></h3>,
    newRecord: () => {
      return {
        email: '',
        accountRole: 'account_member',
        teamId: userStore.account?.teams && userStore.account.teams[0]?.id || '',
        teamRole: 'team_member',
        recordType: 'invitations'
      }
    },
    records: () => {
      return [].concat(userStore.getRecords('invitations', (a, b) => ((a.email.toLowerCase() > b.email.toLowerCase()) ? 1 : (b.email.toLowerCase() > a.email.toLowerCase()) ? -1 : 0)).map(r => {
        r.recordType = 'invitations'
        return r
      }), userStore.getRecords('accountsUsers', (a, b) => {
        const aName = (a.firstName || '').toLowerCase()
        const bName = (b.firstName || '').toLowerCase()
        return aName > bName ? 1 : bName > aName ? -1 : 0
      }).map(r => {
        r.recordType = 'accountsUsers'
        return r
      }))
    },
    filterRecords: () => true,
    formFields: (record) => {
      record = record || { email: '', recordType: 'invitations' }
      if (record.recordType === 'invitations') { return invitationFormFields(record) } else { return memberFormFields(record) }
    },
    saveRecord: (record) => {
      if (record.id && record.recordType === 'accountsUsers') {
        record.accountRole = form.accountRole.value
        record.teamId = form.teamId.value
        record.teamRole = form.teamRole.value
        record.orgNickname = form.orgNickname.value
        userStore.updateAccountsUser(record)
      } else if (record.id && record.recordType === 'invitations') {
        record.email = form.email.value
        record.accountRole = form.accountRole.value
        record.teamId = form.teamId.value
        record.teamRole = form.teamRole.value
        record.orgNickname = form.orgNickname.value
        userStore.updateInvitation(record)
      } else {
        const email = form.email?.value
        const accountRole = form.accountRole?.value
        const teamId = form.teamId?.value
        const teamRole = form.teamRole?.value
        const orgNickname = form.orgNickname?.value
        
        userStore.createInvitation(email, getAccount().id, accountRole, teamId, teamRole, orgNickname)
      }
      return true
    },
    destroy: (record) => {
      if (record.recordType === 'accountsUsers') { userStore.destroyAccountsUser(record) } else { userStore.destroyInvitation(record) }
    },
    renderRecord: (record) => {
      if (record.recordType === 'invitations') {
        // Handle orgNickname safely for invitations too
        const orgNickname = record.orgNickname || ''
        const displayText = orgNickname ? `${record.email} (${orgNickname})` : record.email
        return <div>{displayText} (<Lex term="invitation" />)</div>
      } else {
        const firstName = record.firstName || record.nickname || ''
        const lastName = record.lastName || ''
        const orgNickname = record.orgNickname || ''
        const email = record.email || ''
        
        const displayName = orgNickname || `${firstName} ${lastName}`.trim() || email
        return <div>{displayName} {email !== displayName ? `(${email})` : ''}</div>
      }
    }
  }

  const getTeams = () => {
    if (!teams || teams.length === 0) {
      teams = userStore.getRecords('teams', (a, b) => ((a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0))
    }
    return teams
  }

  const hasAnotherOwner = (accountsUserId) => {
    return userStore.getRecords('accountsUsers', null, u => u.id !== accountsUserId && u.accountRole === 'account_owner').length > 0
  }

  const invitationFormFields = (record) => {
    const orgNicknameValue = typeof record?.orgNickname === 'string' ? record.orgNickname : 
      (record?.orgNickname?.value || '')
    
    return <div>
      <Label><Lex term="email" /></Label>
      {record.id &&
        <div><Input
          data-cy="invitation-email"
          type="hidden" innerRef={el => form.email = el}
          defaultValue={record.email}
        />{record.email}
        </div> ||
          <Input data-cy="invitation-email" innerRef={el => form.email = el} defaultValue={record.email} />}

      <Label>Organization Nickname</Label>
      <Input data-cy="invitation-org-nickname" innerRef={el => form.orgNickname = el} defaultValue={orgNicknameValue} />

      {(!record.id || hasAnotherOwner(record.id)) &&
        <div>
          <Label><Lex term="organization-role" /></Label>
          <Input data-cy="invitation-account-role" type="select" innerRef={el => form.accountRole = el} defaultValue={record.accountRole}>
            <option value="account_member"><Lex term="organization-member" /></option>
            <option value="account_admin"><Lex term= "organization-admin" /></option>
            <option value="account_owner"><Lex term="organization-owner" /></option>
          </Input>
        </div> || <Input type="hidden" innerRef={el => form.accountRole = el} defaultValue={record.accountRole} />}

      {getTeams().length > 0 &&
        <div>
          <Label><Lex term="team" /></Label>
          <Input data-cy="invitation-team" type="select" innerRef={el => form.teamId = el} defaultValue={record.teamId}>
            {getTeams().map((t, i) =>
              <option key={i} value={t.id}>{t.name}</option>)}
          </Input>

          <Label><Lex term="team-role" /></Label>
          <Input data-cy="invitation-team-role" type="select" innerRef={el => form.teamRole = el} defaultValue={record.teamRole}>
            <option value="team_member"><Lex term="team-member" /></option>
            <option value="team_lead"><Lex term="team-lead" /></option>
          </Input>
        </div> || 
        <div>
          <Input type="hidden" innerRef={el => form.teamId = el} defaultValue={record.teamId} />
          <Input type="hidden" innerRef={el => form.teamRole = el} defaultValue={record.teamRole} />
        </div>}

    </div>
  }

  const memberFormFields = (record) => {
    const orgNicknameValue = typeof record?.orgNickname === 'string' ? record.orgNickname : 
      (record?.orgNickname?.value || '')
    
    return <div>
      <Label><Lex term="email" /></Label>
      <div><Input
        data-cy="member-email"
        type="hidden" innerRef={el => form.email = el}
        defaultValue={record.email}
      />{record.email}
      </div>

      <Label>Organization Nickname</Label>
      <Input data-cy="member-org-nickname" innerRef={el => form.orgNickname = el} defaultValue={orgNicknameValue} />

      {(!record.id || hasAnotherOwner(record.id)) &&
        <div>
          <Label><Lex term="organization-role" /></Label>
          <Input data-cy="member-account-role" type="select" innerRef={el => form.accountRole = el} defaultValue={record.accountRole}>
            <option value="account_member"><Lex name="organization-member" /></option>
            <option value="account_admin"><Lex name="organization-admin" /></option>
            <option value="account_owner"><Lex name="organization-owner" /></option>
          </Input>
        </div> || <Input data-cy="member-account-role" type="hidden" innerRef={el => form.accountRole = el} defaultValue={record.accountRole} />}

      {getTeams().length > 0 &&
        <div>
          <Label><Lex term="team" /></Label>
          <Input data-cy="member-team" type="select" innerRef={el => form.teamId = el} defaultValue={record.teamId}>
            {getTeams().map((t, i) =>
              <option key={i} value={t.id}>{t.name}</option>)}
          </Input>

          <Label><Lex term="team-role" /></Label>
          <Input data-cy="member-team-role" type="select" innerRef={el => form.teamRole = el} defaultValue={record.teamRole}>
            <option value="team_member"><Lex term="team-member" /></option>
            <option value="team_lead"><Lex term="team-lead" /></option>
          </Input>
        </div> || 
        <div>
          <Input type="hidden" innerRef={el => form.teamId = el} defaultValue={record.teamId} />
          <Input type="hidden" innerRef={el => form.teamRole = el} defaultValue={record.teamRole} />
        </div>}

    </div>
  }

  return <PageView pageProvider={PageProvider(page)} />
}

export default withUserStore(Members)
